export default __webpack_public_path__ + "static/nora-7e4425b39ea6d63452343916dd5e6783.jpg";